import React, { FC, useState } from "react";
import classNames from "classnames";
import { CloseIcon } from "@/componentsUI/Icon";
import "./index.less";

export interface TagUIProps extends React.HTMLAttributes<HTMLSpanElement> {
  closable?: boolean;
  showClose?: boolean;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  size?: "default" | "large" | string;
}

const TagUI: FC<TagUIProps> = (props) => {
  const {
    children,
    className,
    closable,
    showClose,
    onClose,
    onMouseEnter,
    onMouseLeave,
    size,
    style,
    ...restProps
  } = props;
  const [hoverClose, setHoverClose] = useState(false);
  const closeVisible = Boolean(onClose && (closable || showClose || hoverClose));

  return (
    <span
      {...restProps}
      className={classNames("jokerma-tag-ui", className, {
        "jokerma-tag-ui-large": size === "large",
      })}
      style={{ cursor: "pointer", ...style }}
      onMouseEnter={(event) => {
        setHoverClose(true);
        onMouseEnter?.(event);
      }}
      onMouseLeave={(event) => {
        if (!showClose && !closable) {
          setHoverClose(false);
        }
        onMouseLeave?.(event);
      }}
    >
      <span className="jokerma-tag-ui-content">{children}</span>
      {closeVisible && (
        <button
          type="button"
          className="jokerma-tag-ui-close"
          aria-label="Close"
          onClick={(event) => {
            event.stopPropagation();
            onClose?.(event);
          }}
        >
          <CloseIcon />
        </button>
      )}
    </span>
  );
};

export default TagUI;
